var CKYCDetailsMapper = function (res) {
    if (res) {
        return res.map(function (resp) {
            return {
                AcCode: resp.AcCode,
                UserID: resp.UserID,
                AcName: resp.AcName,
                Email: resp.Email,
                MobileNo: resp.MobileNo,
                PAN: resp.PAN,
                AcType: resp.AcType,
                IsAadhar: resp.IsAadhar,
                BankAccNo: resp.BankAccNo,
                BankName: resp.BankName,
                NEFTCode: resp.NEFTCode,
                DP_Type: resp.DP_Type,
                DP_Id: resp.DP_Id,
                DP_Name: resp.DP_Name,
                DP_AcNo: resp.DP_AcNo,
                Type: resp.Type,
                UpdateLink: resp.UpdateLink,
                Fatca: resp.Fatca,
                FatherName: resp.FatherName,
                MotherName: resp.MotherName,
                ResidentStatus: resp.ResidentStatus,
                Addr1: resp.Addr1,
                Addr2: resp.Addr2,
                Addr3: resp.Addr3,
                City: resp.City,
                PinCode: resp.PinCode,
                State: resp.State,
                Country: resp.Country,
                OccupationType: resp.OccupationType,
                Occupation: resp.Occupation,
                FirstName: resp.FirstName,
                BirthDate: resp.BirthDate,
                Entity: resp.Entity,
                District: resp.District,
                IsName: resp.IsName,
                IsEmail: resp.IsEmail,
                IsPan: resp.IsPan,
                IsMobile: resp.IsMobile,
            };
        });
    }
    return {};
};
export default CKYCDetailsMapper;
